import { render, staticRenderFns } from "./Formulaire.vue?vue&type=template&id=2bcf1f50&"
import script from "./Formulaire.vue?vue&type=script&lang=js&"
export * from "./Formulaire.vue?vue&type=script&lang=js&"
import style0 from "./Formulaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports